<template>
  <div></div>
</template>

<script>
import { Toast } from 'vant';
import { getParkLoginInfo } from '@/api/h5'
export default {
  props: {

  },
  data() {
    return {
      areaId: '',
      appid: '',
      redirect_uri: ''
    };
  },
  components: {

  },
  computed: {

  },
  watch: {

  },
  created() {
    //获取当前url   取到code 
    var url = window.location.href;
    var params = this.parse_url(url);
    this.parkId = params.parkId
    this.areaId = params.areaId

    /**
         * TODO
         * 微信
         * 浏览器
         */
    const wxUrl = 'https://hfive.kunxiangparking.cn'
    const ALiUrl = 'https://hfive.kunxiangparking.cn'
    var browser = navigator.userAgent.toLowerCase();
    //  支付宝浏览器
    if (browser.match(/Alipay/i) == "alipay") {
      if (params.orderNo) {
        // 动态二维码
        this.redirect_uri = `${ALiUrl}/parkingPay?parkId=${this.parkId}&areaId=${this.areaId}`
      } else {
        this.redirect_uri = `${ALiUrl}/parkingPay?parkId=${this.parkId}&areaId=${this.areaId}`
      }
    }
    //  微信浏览器
    else if (browser.match(/MicroMessenger/i) == "micromessenger") {
      if (params.orderNo) {
        // 动态二维码
        this.redirect_uri = encodeURIComponent(`${wxUrl}/parkingPay?parkId=${this.parkId}&areaId=${this.areaId}`)
      } else {
        this.redirect_uri = encodeURIComponent(`${wxUrl}/parkingPay?parkId=${this.parkId}&areaId=${this.areaId}`)
      }
    }
    //  其它浏览器
    else {
      Toast("请使用微信或支付宝进行扫码缴费！");
    }
  },
  mounted() {
    this.getWXappid()
  },
  methods: {
    parse_url(url) { //定义函数
      var pattern = /(\w+)=(\w+)/ig; //定义正则表达式
      var parames = {}; //定义数组
      url.replace(pattern, function (a, b, c) {
        parames[b] = c;
      });
      return parames; //返回这个数组.
    },
    async getWXappid() {
      const { data } = await getParkLoginInfo({
        parkId: this.parkId,
        areaId: this.areaId
      })
      if (data.code == 200) {
        var wxAppId = data.data.wxAppId;
        var ALiAppId = data.data.aliAppId;
        // // 判断当前浏览器是微信还是支付宝
        const browser = navigator.userAgent.toLowerCase();
        //  支付宝浏览器
        if (browser.match(/Alipay/i) == "alipay") {
          window.location.href = "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=" + ALiAppId + "&redirect_uri=" + this.redirect_uri + "&scope=auth_base"
        }
        //  微信浏览器
        else if (browser.match(/MicroMessenger/i) == "micromessenger") {
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + wxAppId + "&redirect_uri=" + this.redirect_uri + "&response_type=code&scope=snsapi_base#wechat_redirect"
        }
        //  其它浏览器
        else {
          Toast("请使用微信或支付宝进行扫码缴费！");
        }

        // var appid = data.data.wxAppId;
        // var redirect_uri = encodeURIComponent(`https://hfive.kunxiangparking.cn/parkingPay?parkId=${this.parkId}&areaId=${this.areaId}`);
        // window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base#wechat_redirect"
      } else {
        Toast(data.msg)
      }
      console.log(data);
    }
  },

};
</script>

<style scoped lang="less"></style>
